import { LocalizationInfoProviderInterface } from "@lib/LocalizationInfoProvider/LocalizationInfoProviderInterface";
import { InjectionKey } from "@lib/svelte-typed-context";
import { CartQuery } from "@modules/cart/queries/CartQuery";
import { CartService } from "@modules/cart/services/CartService";
import LocationControllerInterface from "@modules/common_module/LocationController/LocationControllerInterface";
import { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";
import ShopifyDiscountQuery from "@modules/discount/query/ShopifyDiscountQuery";
import { DiscountService } from "@modules/discount/service/DiscountService";

import NudgesQuery from "./queries/NudgesQuery";
import NudgesService from "./services/NudgesService";
import NudgesPopUpWidgetVisibilityManager from "./widgets/utils/NudgesPopUpWidgetVisibilityManager";

export const nudgesContextToken: InjectionKey<{
    //nudges popup launcher
    NudgesPopUpWidgetVisibilityManager: NudgesPopUpWidgetVisibilityManager;

    //nudges
    nudgesService: NudgesService;
    nudgesQuery: NudgesQuery;

    //cartService
    cartService: CartService;
    cartQuery: CartQuery;

    //shopifyDiscount
    shopifyDiscountApiService: DiscountService;
    shopifyDiscountQuery: ShopifyDiscountQuery;

    //locationController
    locationController: LocationControllerInterface;

    urlsBuilder: URLsBuilder;

    //localizationInfoProvider
    localizationInfoProvider: LocalizationInfoProviderInterface;
}> = Symbol("nudgesContextToken");
